import {Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import {Subscription} from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import {Offset} from '../../../models/Offset';
import {NumAnnoMeseService} from '../../general-services/service-num-anno-mese/num-anno-mese.service';
import {LoaderService} from '../../general-services/service-loader/loader.service';
import {GenericArray} from '../../../models/GenericArray';
import {DialogDetailComponent} from '../../general-components/dialog-detail/dialog-detail.component';
import {ConsuntivoChargesModel} from '../../../models/ConsuntivoChargesModel';
import {ConsuntivoChargesService} from './service-consuntivo-charges/consuntivo-charges.service';
import {BaseGeneralComponent} from '../../BaseGeneralComponent';
import {Router} from '@angular/router';
import {ProviderModel} from '../../../models/ProviderModel';
import {ContractTypeService} from '../../general-services/service-contract-type/contract-type.service';
import {UsersService} from '../../users/service/users.service';
import {ProjectConstants} from '../../project-constants';
import * as toastr from 'toastr';
import {UpdateAllWorkflowStatusDialogComponent} from '../../archive/update-all-workflow-status-dialog/update-all-workflow-status-dialog.component';
import { debounceTime, delay, tap } from 'rxjs/operators';

@Component({
  selector: 'app-consuntivo-charges',
  templateUrl: './consuntivo-charges.component.html',
  styleUrls: ['./consuntivo-charges.component.scss']
})
export class ConsuntivoChargesComponent extends BaseGeneralComponent implements OnInit, OnDestroy {

  sectionId: string;

  displayedColumns: Array<string>;
  dataSource: any;
  isConsumptiveSection: boolean;
  selectedRowIndex: number;
  listData: MatTableDataSource<any>;
  getPageSubscribe: Subscription;
  deleteElementSubscribe: Subscription;

  offset: Offset;
  filter: ConsuntivoChargesModel;
  numAnnoMeseData: any;
  contractTypeData: any;
  showFilter = true;

  providerSelected: ProviderModel;

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  @Input() isRecovery: boolean;
  @Input() reportSection?: boolean;
  @Input() isArchive?: boolean;

  @Output() elementSelected = new EventEmitter();

  isEditing = false;
  editingRows: Array<any> = [];

  constructor(private consuntivoChargesService: ConsuntivoChargesService,
              private numAnnoMeseService: NumAnnoMeseService,
              private contractTypeService: ContractTypeService,
              private userService: UsersService,
              private dialog: MatDialog,
              private loaderService: LoaderService,
              private router: Router) {
    super();
    this.sectionId = this.SECTIONS.MONTHLY_CHARGES;
    this.user = JSON.parse(sessionStorage.getItem('user'));
    this.loaderService.display(true);
  }

  ngOnInit() {
    this.isConsumptiveSection = this.returnIsContractSection(this.router.url);
    this.providerSelected = JSON.parse(sessionStorage.getItem(this.SESSION_STORAGE_LABELS.DEFAULT_PROVIDER_SELECTED)) as ProviderModel;
    this.selectedRowIndex = -1;

    if (this.providerSelected.description === this.PROVIDER_IBM) {
      if (this.isArchive) {
        this.displayedColumns = ['workflowStatus', 'numAnnoMeseRif', 'docType', 'regionDesc', 'localCustomerDesc',
          'contractTypeDesc', 'resourceUnitCod', 'resourceUnitName', 'charge', 'actions'];
      } else if (this.isRecovery) {
        this.displayedColumns = ['numAnnoMeseRif', 'docType', 'regionDesc', 'localCustomerDesc',
        'contractTypeDesc', 'resourceUnitCod', 'resourceUnitName', 'charge', 'actions'];
      } else {
        this.displayedColumns = ['numAnnoMeseRif', 'regionDesc', 'localCustomerDesc',
        'contractTypeDesc', 'resourceUnitCod', 'resourceUnitName', 'charge', 'actions'];
      }
    } else if(this.providerSelected.description.includes(this.PROVIDER_KYN)){
      if (this.isArchive) {
        this.displayedColumns = ['workflowStatus', 'numAnnoMeseRif', 'docType', 'regionDesc', 'localCustomerDesc',
          'resourceUnitCod', 'resourceUnitName','actualVolume', 'charge', 'actions'];
      } else if (this.isRecovery) {
        this.displayedColumns = ['numAnnoMeseRif', 'docType', 'regionDesc', 'localCustomerDesc',
        'resourceUnitCod', 'resourceUnitName','actualVolume', 'charge', 'actions'];
      } else {
        this.displayedColumns = ['numAnnoMeseRif', 'srv', 'regionDesc', 'referenceRegion',
          'servicesCountry' , 'referenceCountry' , 'billingCountry' , 'localCustomerDesc',
        'resourceUnitCod', 'resourceUnitName','currencyCod', 'actualVolume', 'charge', 'actions'];
      }
    }else {
      this.displayedColumns = ['numAnnoMeseRif', 'numAnnoMeseAcceptance', 'residualMonth',
        'regionDesc', 'localCustomerDesc', 'contractTypeDesc',
        'resourceUnitCod', 'resourceUnitName', 'serviceVariantCod', 'charge', 'notes', 'actions'];
    }
    this.offset = this.setOffsetInSession(this.offset, this.OFFSET_NAME.CONSUMPTIVE_CHARGES_OFFSET);
    this.getSessionStorageFilter();
    this.userService.getUserSectionGrant(this.user.id, this.sectionId).subscribe(
      (result: any) => {
        this.setUserGrants(result);
      });
    this.init();
  }

  init() {
    this.filter.isRecovery = this.isRecovery;
    this.filter.docType = this.filter.isRecovery ? this.filter.docType : null;
    this.numAnnoMeseService.getAllMonth(this.filter.provider, this.filter.contractType).subscribe(
      (resultYearMonth: any) => {
        const providerDefault = this.filter.provider;
        this.numAnnoMeseData = this.filterFromDxc(providerDefault, resultYearMonth);

        if (!this.filter.numAnnoMese) {
          this.numAnnoMeseService.getLastConsumptiveVolMonth(this.providerSelected).subscribe(
            res => {
              this.filter.numAnnoMese = res;
              if (this.reportSection) {
                this.showFilter = true;
              } else {
                this.getDataPage(this.offset, this.filter);
              }
            }
          );
        } else {
          if (!this.reportSection) {
            // this.showFilter = false;
            this.getDataPage(this.offset, this.filter);
          } else {
            this.showFilter = true;
          }
        }          },
          error => {
            console.log(error);
            this.loaderService.display(false);
          });
  }

  getDataPage(offset: Offset, filter: ConsuntivoChargesModel) {
    this.loaderService.display(true);
    this.getPageSubscribe = this.consuntivoChargesService.getPage(offset, filter)
    .pipe(
      tap(() => this.loaderService.display(true)),
      debounceTime(0),
      delay(0),
      tap(() => this.loaderService.display(false)),
    ).subscribe(
        (resultPage: any) => {
          this.dataSource = resultPage.content;
          this.listData = new MatTableDataSource(this.dataSource);
          this.listData.sort = this.sort;
          this.paginator.pageIndex = offset.pageIndex;
          this.paginator.showFirstLastButtons = true;
          this.paginator.length = resultPage.totalElements;
          this.loaderService.display(false);
        });
  }

  openDialog(id: number) {
    const consuntivoCharges = this.dataSource.find(data => data.id === id) as ConsuntivoChargesModel;
    const list: GenericArray[] = [
      {id: 'Month', value: this.toCustomStringAnnoMese(consuntivoCharges.numAnnoMese)},
      {id: 'Reference Month', value: this.toCustomStringAnnoMese(consuntivoCharges.numAnnoMeseRif)},
      {id: 'Doc Type', value: this.toCustomString(consuntivoCharges.docType)},
      {id: 'Provider Cod', value: this.toCustomString(consuntivoCharges.provider.cod)},
      {id: 'Provider Description', value: this.toCustomString(consuntivoCharges.provider.description)},
      {id: 'Region Cod', value: this.toCustomString(consuntivoCharges.region.cod)},
      {id: 'Region Description', value: this.toCustomString(consuntivoCharges.region.description)},
      {id: 'Local Customer Cod', value: this.toCustomString(consuntivoCharges.localCustomer.cod)},
      {id: 'Local Customer Description', value: this.toCustomString(consuntivoCharges.localCustomer.description)},
    //  {id: 'Contract Type Cod', value: this.toCustomString(consuntivoCharges.contractType.description)},
    //  {id: 'Contract Type Description', value: this.toCustomString(consuntivoCharges.contractType.description)},
      {id: 'Resource Unit Cod', value: this.toCustomString(consuntivoCharges.resourceUnit.cod)},
      {id: 'Resource Unit Name', value: this.toCustomString(consuntivoCharges.resourceUnit.name)},
      {id: 'ConsumptiveCharge', value: this.toCustomString(consuntivoCharges.charge)},
      {id: 'ServiceVariant', value: this.toCustomString(consuntivoCharges.serviceVariant ? consuntivoCharges.serviceVariant.cod : '')},
      {id: 'Is Recovery', value: this.toCustomStringIs(consuntivoCharges.isRecovery)},
      {id: 'Note', value: this.toCustomString(consuntivoCharges.notes)}
    ];

    if (this.providerSelected.description === this.PROVIDER_DXC) {
      list.push({id: 'Notes', value: this.toCustomString(consuntivoCharges.notes)});
    }
    this.dialog.open(DialogDetailComponent, {
      width: '40%',
      data: {list}
    });
  }


  getNext(event: PageEvent) {
    this.loaderService.display(true);
    const tmpOffset = new Offset(event.pageSize, event.pageIndex);
    this.setOffsetInSession(tmpOffset, this.OFFSET_NAME.CONTRACTUAL_VALUES_OFFSET);
    tmpOffset.orderDirection = this.offset.orderDirection;
    tmpOffset.orderField = this.offset.orderField;
    this.offset = tmpOffset;
    this.getDataPage(this.offset, this.filter);
  }

  getDataFiltered(dataFiltered: any) {
    this.offset = new Offset(+this.PAGINATOR.PAGE_SIZE_ARRAY[0], 0);
    this.filter = dataFiltered.filter;
    this.offset.actualQuantityFilter = dataFiltered.actualQuantityFilter;
    if (!this.reportSection) {
      this.getDataPage(this.offset, this.filter);
    }  }

  sortData(sort: Sort) {
    this.loaderService.display(true);
    if ((sort.active !== null || true || sort.active !== '') && (sort.direction !== '' || sort.direction !== null || true)) {
      if (this.offset === null || this.offset === undefined) {
        this.offset = new Offset(+this.PAGINATOR.PAGE_SIZE_ARRAY[0], 0);
      }

      this.offset.orderField = sort.active;
      this.offset.orderDirection = sort.direction;

      this.getDataPage(this.offset, this.filter);
    }

  }

  selectRow(row: any) {
    this.selectedRowIndex = row.id;
    this.elementSelected.emit({ row });
  }

  ngOnDestroy(): void {
    if (this.getPageSubscribe) {
      this.getPageSubscribe.unsubscribe();
    }

    if (this.deleteElementSubscribe) {
      this.deleteElementSubscribe.unsubscribe();
    }
  }

  toggleFilter() {
    if (!this.reportSection) {
      this.showFilter = !this.showFilter;
    }
  }

  getSessionStorageFilter() {
    const filter_ = JSON.parse(sessionStorage.getItem(this.SESSION_STORAGE_LABELS.CONSUMPTIVE_CHARGES_FILTER));
    this.filter = filter_ ? filter_ : new ConsuntivoChargesModel();
    this.filter.provider = JSON.parse(sessionStorage.getItem(this.SESSION_STORAGE_LABELS.DEFAULT_PROVIDER_SELECTED));
  }

  getCurrentElementWorkflowStatus(element: any) {
    if (element && element.workflowStatus && element.workflowStatus !== '') {
      return element.workflowStatus;
    } else {
      return 'NO_MAT_OPTION_SELECTED';
    }
  }

  onChangeWorkflowStatus($event, status, element) {
    if ($event && $event.isUserInput && status && element && element.workflowStatus && element.workflowStatus !== status) {
      console.log($event, status, element);
      if (!this.isEditing) {
        this.isEditing = true;
        this.editingRows = [];
      }
      element.workflowStatus = status;
      this.editingRows.push(element);
    }
  }

  get workflowStatusList() {
    return new ProjectConstants().WORKFLOW_STATUS_LIST;
  }

  updateWorkflowStatusSingle() {
    this.consuntivoChargesService.updateWorkflowStatusSingle(this.editingRows).subscribe(
      (result: any) => {
        this.isEditing = false;
        toastr.success('Plains updated with success', 'Success');
        this.editingRows = [];
        this.getDataPage(this.offset, this.filter);
      }, error => {
        this.loaderService.display(false);
        toastr.error('A problem has occurred, please contact the Administrator', 'Error');
      }
    );
  }

  openMassiveWorkflowStatusEditDialog() {
    const chargesList = this.dataSource;
    const dialogRef = this.dialog.open(
      UpdateAllWorkflowStatusDialogComponent,
      {
        width: '40%',
        data: {
          chargesList
        }
      }
    );
  }

  openNotes(id: number) {
    const selectedData = this.dataSource.find(data => data.id === id);
    const list: GenericArray[] = [
      {id: 'Note', value: (!selectedData.notes) ? 'N.D.' : selectedData.notes}
    ];
    const note = true;
    const serviceType = 'charges';
    const discountData = selectedData; // per compatibilita' con il componente del dialog
    const dialogRef = this.dialog.open(DialogDetailComponent, {
      width: '40%',
      data: {list, note, discountData, serviceType}
    });

    dialogRef.afterClosed().subscribe(result => {
      this.getDataPage(this.offset, this.filter);
    });
  }

  checkConsolidation(): boolean {
    if (!this.dataSource || this.dataSource.length === 0) {
      return false;
    } else {
      if (this.dataSource.every(element => element.workflowClosed === true)) {
        return true;
      } else {
        return false;
      }
    }
  }

}
